import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
	Button,
	Form,
	FormGroup,
	Row,
	Col,
	Input,
	FormFeedback,
	Label,
} from "reactstrap";
import { FloppyDisk, SignOut } from "@phosphor-icons/react";
import userRoleService from "services/UserRoleService";

const CreateEditUserRoleModal = ({ show, onCloseClick, data }) => {
	const id = data?.id;

	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: data?.name || "",
		},

		validationSchema: Yup.object({
			name: Yup.string().required("Por favor, informe a função."),
		}),

		onSubmit: async (values) => {
			try {
				if (id) {
					await userRoleService.put(id, values);
				} else {
					await userRoleService.post(values);
				}
				onCloseClick();
			} catch (error) {
				console.log(error);
			}
		},
	});

	return (
		<>
			<Modal
				size="sm"
				isOpen={show}
				toggle={onCloseClick}
				centered={true}
				style={{ minWidth: 800 }}
			>
				<div className="modal-content">
					<ModalBody className="px-4 py-3 text-center">
						<Col md="12">
							<Form
								className="needs-validation"
								onSubmit={(e) => {
									e.preventDefault();
									validation.handleSubmit();
								}}
							>
								<h4 className="text-center my-4">
									{id ? "Editar Função" : "Nova Função"}
								</h4>

								{/* Função */}
								<Row>
									<Col md="12">
										<FormGroup className="mb-3">
											<Label
												htmlFor="name"
												style={{ display: "flex" }}
											>
												Nome da Função{" "}
												<span style={{ color: "red" }}>
													*
												</span>
											</Label>
											<Input
												name="name"
												type="textarea"
												placeholder="Digite o nome da função"
												onChange={
													validation.handleChange
												}
												onBlur={validation.handleBlur}
												value={
													validation.values.name || ""
												}
												invalid={
													validation.touched.name &&
													Boolean(
														validation.errors.name,
													)
												}
											/>
											{validation.touched.name &&
											validation.errors.name ? (
												<FormFeedback type="invalid">
													{validation.errors.name}
												</FormFeedback>
											) : null}
										</FormGroup>
									</Col>
								</Row>

								{/* Botões de Submissão e Fechamento */}
								<Row className="py-1">
									<div className="hstack gap-2 justify-content-center mb-0">
										<Button
											type="submit"
											disabled={validation.isSubmitting}
											style={{
												background: "none",
												padding: 10,
												cursor: "pointer",
												color: "black",
												marginLeft: 10,
												width: 150,
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
												gap: 2,
											}}
										>
											{validation.isSubmitting ? (
												<span
													className="spinner-border spinner-border-sm mr-1"
													style={{ marginRight: 10 }}
												></span>
											) : null}
											<FloppyDisk size={16} /> Salvar
										</Button>
										<Button
											type="button"
											onClick={onCloseClick}
											style={{
												background: "none",
												padding: 10,
												cursor: "pointer",
												color: "black",
												marginLeft: 10,
												width: 150,
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
												gap: 2,
											}}
										>
											<SignOut size={16} /> Fechar
										</Button>
									</div>
								</Row>
							</Form>
						</Col>
					</ModalBody>
				</div>
			</Modal>
		</>
	);
};

CreateEditUserRoleModal.propTypes = {
	show: PropTypes.bool,
	onCloseClick: PropTypes.func,
	data: PropTypes.any,
};

export default CreateEditUserRoleModal;
